import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import { useAppStore } from './stores/app';
import { useWhitelabel } from './composables/useWhitelabel';
import "./index.css";
import App from './App.vue';

// Importar KTUI para disponibilizar componentes globalmente
import "@keenthemes/ktui/dist/ktui.js";
import "./metronic/core/index";
import "./metronic/app/layouts/demo1";
// @ts-ignore - Componentes KTUI podem não ter tipos exportados
import { KTSelect } from '@keenthemes/ktui';
// import { KTDatePicker } from './metronic/core/components/date-picker';
// import { KTAccordion, KTTabs } from '@keenthemes/ktui/src';
import { KTColorPicker } from './metronic/core/components/color-picker';
import * as Sentry from '@sentry/vue';
import { initSentry } from './plugins/sentry';
import { setSentryAppContext } from './plugins/sentry-context';
// DataTables.net é usado via composable useDataTablesNet (Metronic Tailwind docs)

// Disponibilizar componentes KTUI no window global se ainda não estiverem disponíveis
if (typeof window !== 'undefined') {
    // @ts-ignore
    if (!window.KTSelect) window.KTSelect = KTSelect;
//     // @ts-ignore
//     if (!window.KTDatePicker) window.KTDatePicker = KTDatePicker;
//     // @ts-ignore
//     if (!window.KTTabs) window.KTTabs = KTTabs;
//     // @ts-ignore
//     if (!window.KTAccordion) window.KTAccordion = KTAccordion;
    // @ts-ignore
    if (!window.KTColorPicker) window.KTColorPicker = KTColorPicker;
}


const app = createApp(App);

initSentry({ app, router });
setSentryAppContext();

const pinia = createPinia();
app.use(pinia);

app.use(router);


// Função para inicializar a aplicação
const initializeApp = async () => {
  // Inicializar configurações da aplicação
  const appStore = useAppStore();
  appStore.init();

  // Inicializar whitelabel e carregar configurações
  const whitelabel = useWhitelabel();
  await whitelabel.loadWhitelabelConfig();

  // Montar a aplicação após inicialização completa
  app.mount('#app');
};

// Inicializar a aplicação
initializeApp().catch((error: unknown) => {
  console.error('❌ Erro ao inicializar aplicação:', error);
  Sentry.captureException(error, { tags: { feature: 'app_init' } });
  // Montar mesmo com erro para não travar a aplicação
  app.mount('#app');
});
